import React, { Fragment, memo, useMemo, useState } from "react";
import { ILocationStats } from "../../../store/useDropLocations";

interface Props {
  location: ILocationStats;
  showTarget: boolean;
}

export const PercentageActiveUsers = memo((props: Props) => {
  /** State */
  const [target, setTarget] = useState<number | null>(null);

  /** Callbacks */
  const handleTarget = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTarget(Number(Number(value ?? 0).toFixed(2)));
  };

  const percentage = useMemo(() => {
    if (!target || target === 0) {
      return target === 0 ? 0 : Infinity; // Avoid division by zero
    }
    const difference =
      Number(Number(props.location?.activeUsers / props.location?.allUsers).toFixed(2)) -
      target;
    const percentageDifference = (difference / target) * 100;
    return percentageDifference;
  }, [props.location?.activeUsers, props.location?.allUsers, target]);

  return (
    <Fragment key={props.location._id}>
      {props.showTarget && (
        <td className="border border-gray-300 text-center">
          <input
            className="px-4 py-3 h-full w-full text-center border border-gray-500 focus:border-cc-green ring-0 focus:ring-0 focus:outline-none"
            value={target ?? ''}
            placeholder="0"
            onChange={handleTarget}
            type="number"
            step="any"
          />
        </td>
      )}
      <td className="border border-gray-300 px-4 py-2 text-center">
        {Number(Number(props.location?.activeUsers / props.location?.allUsers) * 100).toFixed(2)} %
        {target ? <p
          className={`font-satoshi text-xs ${Number(percentage ?? 0) >= 0 ? "text-green-500" : "text-red-500"
            }`}
        >
          {Number(percentage ?? 0).toFixed(2)} %
        </p> : null}
      </td>
    </Fragment>
  );
});
